import { render, staticRenderFns } from "./AccordianItem.vue?vue&type=template&id=3fa4589f&scoped=true"
import script from "./AccordianItem.vue?vue&type=script&lang=js"
export * from "./AccordianItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa4589f",
  null
  
)

export default component.exports